import { z } from 'zod'

export const FoodRestrictionType = z.enum([
  'ALLERGENS',
  'RESTRICTED_FOODS',
  'FOOD_SELECTIVITY',
  'FOOD_PREFERENCE'
])
export type FoodRestrictionType = z.infer<typeof FoodRestrictionType>
